<script>
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import { toArrayBuffer, formatDate } from "src/utils";
import Grid from "../Shared/Grid";
import { saveAs } from "file-saver"
const moment = require("moment");

export default {
  name: "ClassCertificates",
  components: {
    Grid
  },
  data() {
    return {
      moment: moment,
      module: this.$route.meta.module,
      rowsPerPageOptions: [],
      columnOptions: [
        {
          visible: false,
          field: "CERTIFICATE_CODE",
          name: "CERTIFICATE_CODE",
          label: "Certificate Code",
          sortable: false,
          filterable: false,
          filter: "",
          type: "string"
        },
        {
          field: "STUDENT",
          name: "DRIVERS_LICENSE",
          label: "DL #",
          sortable: false,
          filterable: true,
          filter: "",
          type: "string",
          format: r => {
            return r ? r.DRIVERS_LICENSE.DRIVERS_LICENSE : null;
          }
        },
        {
          field: "STUDENT",
          name: "STUDENT_FIRST_NAME",
          label: "First Name",
          sortable: false,
          filterable: true,
          filter: "",
          type: "string",
          format: r => {
            return r ? r.STUDENT_FIRST_NAME : null;
          }
        },
        {
          field: "STUDENT",
          name: "STUDENT_LAST_NAME",
          label: "Last Name",
          sortable: false,
          filterable: true,
          filter: "",
          type: "string",
          format: r => {
            return r ? r.STUDENT_LAST_NAME : null;
          }
        },
        {
          field: "PRINTED_IND",
          name: "PRINTED",
          label: "Printed",
          sortable: false,
          filterable: true,
          filter: "",
          type: "string",
          align: "center"
        },
        {
          name: "DATE_CREATED",
          label: "Date Issued",
          field: "DATE_CREATED",
          sortable: false,
          filterable: false,
          filter: "",
          type: "date",
          align: "left"
        }
      ]
    };
  },
  mounted(){
    let vm = this
    if(!vm.canPrintCertificates) vm.onSelectDownload = false

    const pdfFrame = vm.$refs.pdfFrame
    pdfFrame.onload = () => {
      try {
        pdfFrame.contentWindow.print()
      } catch (err) {
        console.log('print error:', err)
      } finally {
        URL.revokeObjectURL(pdfFrame.src)
      }
    }
  },
  computed: {
    ...mapState({
      certificates: s => s.classes.sessionInformation.certificates,
      loadingCertificates: s => s.classes.loadingCertificates,
      class: s => s.classes.sessionInformation,
    }),
    canPrintCertificates(){
      let vm = this
      return (vm.currentUser().PRINT_PERMISSION && vm.$p(['AFFILIATE'])) || vm.$p(['ADMIN','MANAGER'],'or')
    },
    visibleColumns(){
      return ['DRIVERS_LICENSE','STUDENT_FIRST_NAME','STUDENT_LAST_NAME','PRINTED','DATE_CREATED']
    }
  },
  methods: {
    ...mapActions("certificates", ["fetchClass", "print"]),
    ...mapActions("classes", [ "generateCertificates"]),
    async onSelectDownload(certificate) {
      let vm = this
      console.log('certificates', certificate)
      this.generateCertificates([certificate])
      .then(response => {
        console.log('response', response)
        const certificateName = formatDate(certificate.CLASS.CLASS_START_DATE) + ' - ' + certificate.STUDENT.STUDENT_FIRST_NAME + ' ' + certificate.STUDENT.STUDENT_LAST_NAME +'.pdf'
        saveAs(response.data, certificateName)
        vm.$root.$emit("refreshGrid:certificatesListGrid");
      });
    },
    async downloadAllCertificates() {
      let vm = this
      this.generateCertificates(this.certificates)
      .then(response => {
        console.log('this.certificates', this.certificates)
        const certData = this.certificates[0].CLASS
        const certificateName = certData.AFFILIATE.AFFILIATE_CODE + ' ' + certData.AFFILIATE.AFFILIATE_NAME + ' ' + formatDate(certData.CLASS_START_DATE) + '.pdf'
        saveAs(response.data, certificateName)
        vm.$root.$emit("refreshGrid:certificatesListGrid");
      });
    },
    printOneOrMoreCertificates(certificates) {
      const vm = this
      const pdfFrame = vm.$refs.pdfFrame

      if (!Array.isArray(certificates)) {
        certificates = [certificates]
      }

      if (vm.certificates.length > 0) {
        vm.generateCertificates(certificates)
          .then(response => {
            const pdf = response.data
            pdfFrame.src = URL.createObjectURL(pdf)
            vm.print({ certificateIds: vm.certificates.map(c => c.CERTIFICATE_ID) })
              .then(() => {
                vm.$root.$emit("refreshGrid:certificatesListGrid");
              })
          })
      }
    },
    printAllCertificates() {
      this.printOneOrMoreCertificates(this.certificates)
    },
  }
};
</script>

<template>
  <div class="fit">
    <Grid
      id="certificatesListGrid"
      :module="module"
      :data="certificates"
      :rows-per-page-options="[0]"
      :columns="columnOptions"
      :onRequest="fetchClass"
      :onExport="fetchClass"
      :onDownload="onSelectDownload"
      :onPrint="printOneOrMoreCertificates"
    >
      <template slot="header-left" slot-scope="props" v-if="canPrintCertificates">
        <q-btn
        icon="fa fa-list-alt"
        size="md"
        outline
        color="green"
        label="Download All"
        :loading="loadingCertificates"
        @click="downloadAllCertificates()"
      >
        <q-spinner-puff slot="loading" />
      </q-btn>
        <q-btn
        icon="fa fa-print"
        style="margin-left: 0.5em"
        size="md"
        outline
        color="purple"
        :loading="loadingCertificates"
        @click="printAllCertificates()"
        v-if="$p(['ADMIN'])"
      >
        <q-tooltip anchor="bottom middle" :offset="[0, 50]">Print All</q-tooltip>
        <q-spinner-puff slot="loading" />
      </q-btn>
      </template>
      <template slot="col-item-printed" slot-scope="props">
        <i
          style="font-size:20px"
          class="fa"
          :class="{
                'fa-minus text-purple': props.value == 2,
                'fa-check text-green': props.value == 1,
                'fa-close text-red' : props.value == 0
              }"
        >
          <q-tooltip
            anchor="bottom middle"
            :offset="[0, 50]"
            v-if="props.value == 2"
          >
            Printing Not Required
          </q-tooltip>
        </i>
      </template>
    </Grid>
    <iframe style="display: none" ref="pdfFrame"></iframe>
  </div>
</template>

<style>
</style>